import { Button } from '@repo/shadcn';

import { PlusIcon } from '@assets/svg.icons/icons.tsx';

import { DEFAULT_PAGE_LIMIT, DEFAULT_PAGE_NUMBER } from '@/constants';

import { DataTable } from '../../../ui/data.table/data-table';
import HeadingWrapper from '../../../ui/heading/heading-wrapper';
import PageHeading from '../../../ui/heading/page-headeing';
import PaginationComponent from '../../../ui/pagination';
import { expenseCategoryColumns } from './expense-category.column';
import { useExpenseCategory } from './expense-category.hook';

export const ExpenseCategory = () => {
    const {
        data,
        isLoading,
        isError,
        setCurrentPage,
        openCreateExpenseCategoryModal,
    } = useExpenseCategory();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (isError) {
        return (
            <div>
                <p>Something went wrong!</p>
            </div>
        );
    }

    return (
        <>
            <HeadingWrapper>
                <div className="flex items-center justify-between py-4">
                    <PageHeading
                        title="Expense Category"
                        subTitle="Manage Your Expense Categories"
                    />

                    <div className="flex gap-4">
                        <Button
                            type="button"
                            onClick={openCreateExpenseCategoryModal}
                        >
                            <PlusIcon />
                            Add Category
                        </Button>
                    </div>
                </div>
            </HeadingWrapper>

            <DataTable
                columns={expenseCategoryColumns}
                data={data?.data || []}
            />

            <p className=" mt-3 flex w-full items-center px-4 text-right text-[20px] font-semibold">
                Total Found : {data?.pagination?.total_items}
            </p>
            <PaginationComponent
                totalItems={data?.pagination?.total_items || 0}
                itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                initialPage={DEFAULT_PAGE_NUMBER}
                onPageChange={(p) => {
                    setCurrentPage(p);
                }}
            />
        </>
    );
};
